export default __webpack_public_path__ + "static/events-dark-2734ca63989e70d889a305572121e18b.png";